export const DEFAULT_SPACING = 8;

export const getSpacing = (times: number): string =>
  `${DEFAULT_SPACING * times}px`;
